import * as React from 'react'
import TextField from '@mui/material/TextField'
import { DatePicker } from '@mui/x-date-pickers'
import moment, { Moment } from 'moment'

import { errorRed, fieldBorderGray, mainBlue } from '../../shared/styles/colors'

import './CustomDatepicker.sass'

type EventProps = {
    onChange: (date: moment.Moment) => void
    onInput?: (event: any) => void
}

type DateFieldProps = {
    required?: boolean
    dateFormat: string
    value: Date | null
    placeholder?: string
    label?: string
    invalidLabel?: string
    minDateMessage?: string
    maxDateMessage?: string
    disablePast?: boolean
    disableFuture?: boolean
    error?: boolean
    mask?: string
    autoOk?: boolean
}

type Props = EventProps & DateFieldProps

export default class CustomDatepicker extends React.PureComponent<Props> {
    onInput = (event: React.FormEvent<HTMLDivElement>) => this.props.onInput && this.props.onInput(event)

    onChange = (d: Moment | null) => {
        if (d) {
            this.props.onChange && this.props.onChange(d)
        }
    }

    render() {
        const {
            required,
            value,
            dateFormat,
            placeholder,
            label,
            invalidLabel: _inv,
            disablePast,
            disableFuture,
            minDateMessage: _minM,
            maxDateMessage: _maxM,
            error,
            autoOk: _auto,
        } = this.props

        return (
            <div className="custom-datepicker">
                <DatePicker
                    label={label}
                    value={value ? moment(value) : null}
                    onChange={this.onChange}
                    inputFormat={dateFormat}
                    disablePast={Boolean(disablePast)}
                    disableFuture={Boolean(disableFuture)}
                    renderInput={params => {
                        const hasError = Boolean(error || params.error)

                        return (
                            <TextField
                                {...params}
                                color="primary"
                                style={{ color: mainBlue }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        height: '39.5px',
                                        borderRadius: '6px',
                                        backgroundColor: 'white',
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: hasError ? errorRed : fieldBorderGray,
                                        },
                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                            borderColor: hasError ? `${errorRed} !important` : `${mainBlue} !important`,
                                        },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: hasError ? errorRed : mainBlue,
                                            borderWidth: '1px',
                                        },
                                    },
                                }}
                                placeholder={placeholder}
                                onInput={this.onInput}
                                error={hasError}
                                required={required}
                                variant="outlined"
                            />
                        )
                    }}
                />
            </div>
        )
    }
}
